"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resguardoRecibidoConverter = void 0;
const resguardoRecibidoConverter = {
    toFirestore(resguardoRecibido) {
        return resguardoRecibido;
    },
    fromFirestore(snapshot) {
        const data = snapshot.data();
        return {
            id: data.id,
            numero: data.numero,
            activo: data.activo,
            emisorId: data.emisorId,
            emisorString: data.emisorString,
            localId: data.localId,
            fecha: data.fecha,
            receptorId: data.receptorId,
            moneda: data.moneda,
            cotizacion: data.cotizacion,
            comprobante: data.comprobante,
            retenciones: data.retenciones,
            referencias: data.referencias,
            observaciones: data.observaciones,
            valor: data.valor,
            cfeId: data.cfeId,
            cfeNumero: data.cfeNumero,
            cfeSerie: data.cfeSerie,
            cfeTipo: data.cfeTipo
        };
    }
};
exports.resguardoRecibidoConverter = resguardoRecibidoConverter;
